import React from 'react'
import { IconDownloadSvg } from '../../../../assets/icons/svgComponents'
import { Button, SelectInput } from '../../../../components'
import * as S from './styles'
type Props = {
  header: string
  table: any
  options: string[]
  setPeriods: React.Dispatch<React.SetStateAction<string>>
}
export const BillingModal = ({ header, table, options, setPeriods }: Props) => {
  return (
    <S.Wrapper>
      <S.Header>
        {header}
        <SelectInput
          name=""
          wrapperClassName="date-select"
          options={options.map((item) => {
            return { value: item, label: item }
          })}
          onChange={(e) => setPeriods(e.target.value)}
        />
        <Button>
          <IconDownloadSvg />
        </Button>
      </S.Header>
      <S.Body>
        <S.DataContainer>{table}</S.DataContainer>
      </S.Body>
    </S.Wrapper>
  )
}
